/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const checkConditon = (props) => {
  const condition = !props.spc
    ? 'background-color: rgba(0, 0, 0, 0.42);'
    : 'background-color: rgba(0, 0, 0, 0.42)';
  return props.spc &&
    (!props.applePayInProgress ||
      !props.isPLCCModalOpen ||
      !props.afterPayPaymentProgress ||
      !props.isPaypalPaymentProgress)
    ? ''
    : condition;
};
const styles = css`
  .spinner-overlay {
    position: fixed;
    width: 100%;
    height: ${(props) => (props.fromPlccICLogin ? '120%' : '100%')};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    ${(props) =>
      props.spc &&
      (props.applePayInProgress ||
        props.isPLCCModalOpen ||
        props.afterPayPaymentProgress ||
        props.isPaypalPaymentProgress)
        ? 'background-color: rgba(0, 0, 0, 0.42);'
        : checkConditon(props)}
    z-index: 1400;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    display: flex;
    @media (max-height: 720px) {
      height: ${(props) =>
        (props.isNewLoginScreen && props.isLoginModal) || props.fromPlccICLogin ? '160%' : '100%'};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: ${(props) =>
        (props.isNewLoginScreen && props.isLoginModal) || props.fromPlccICLogin ? '135%' : '100%'};
    }
  }

  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;

export default styles;
